import i from"@emotion/styled";import{setColor as t,setFontSize as d}from"../../utils/generateStyles.js";var p=Object.defineProperty,c=Object.defineProperties,s=Object.getOwnPropertyDescriptors,l=Object.getOwnPropertySymbols,b=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable,n=(e,r,o)=>r in e?p(e,r,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[r]=o,a=(e,r)=>{for(var o in r||(r={}))b.call(r,o)&&n(e,o,r[o]);if(l)for(var o of l(r))u.call(r,o)&&n(e,o,r[o]);return e},y=(e,r)=>c(e,s(r));const f=i.div`
  label: radio;
  position: relative;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  column-gap: 8px;
  ${e=>e.disabled&&{cursor:"default"}}
`,g=i.div`
  label: radio-icon;
  position: relative;
  border-radius: 100%;
  display: block;
  min-width: 16px;
  min-height: 16px;
  width: 16px;
  height: 16px;
  border: 1px solid;
  ${()=>t("blue-50","borderColor")};
  ${e=>e.disabled&&a({opacity:"0.6"},t("gray-90","borderColor"))};
  ${e=>e.checked&&{"&::after":y(a({content:'""',position:"absolute",display:"block",width:"calc(50% + 1px)",height:"calc(50% + 1px)"},t("blue-80","backgroundColor")),{left:0,top:0,right:0,bottom:0,margin:"auto",borderRadius:"100%"})}};
`,h=i.div`
  label: radio-title;
  font-weight: 500;
  ${()=>d("xs")};
  ${()=>t("gray-black","color")};
  ${e=>e.fullWidth&&{width:"100%"}};
  ${e=>e.disabled&&a({},t("gray-90","color"))};
`,m=i.input`
  display: none;
`;export{g as RadioIconStyled,m as RadioInputStyled,f as RadioStyled,h as RadioTitleStyled};
